/* Car phone holder store (2026-10-25): gallery, tiers, add to cart into the Dawn drawer, sticky bar, accordions, video sound. */
(function () {
  function money(cents) {
    var f = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    try { return new Intl.NumberFormat('en-US', { style: 'currency', currency: f }).format(cents / 100); } catch (e) { return '$' + (cents / 100).toFixed(2); }
  }

  function initMain(root) {
    var unit = +root.dataset.unit || 0;
    var track = root.querySelector('[data-cm-track]');
    var thumbs = root.querySelectorAll('.cm-gal__th');
    if (track && thumbs.length) {
      thumbs.forEach(function (b) {
        b.addEventListener('click', function () { track.scrollTo({ left: track.clientWidth * +b.dataset.go, behavior: 'smooth' }); });
      });
      var t;
      track.addEventListener('scroll', function () {
        clearTimeout(t);
        t = setTimeout(function () {
          var i = Math.round(track.scrollLeft / track.clientWidth);
          thumbs.forEach(function (b, k) { b.classList.toggle('is-on', k === i); });
        }, 60);
      }, { passive: true });
    }

    var tiers = root.querySelectorAll('.cm-tier');
    var atcPrice = root.querySelector('[data-cm-atc-price]');
    var stLabel = root.querySelector('[data-cm-sticky-label]');
    var stPrice = root.querySelector('[data-cm-sticky-price]');
    function current() { return root.querySelector('.cm-tier.is-on') || tiers[0]; }
    function paint() {
      var c = current(); if (!c) return;
      var price = money(unit * +c.dataset.paid);
      if (atcPrice) atcPrice.textContent = price;
      if (stPrice) stPrice.textContent = price;
      if (stLabel) stLabel.textContent = c.querySelector('.cm-tier__t').firstChild.textContent.trim();
    }
    tiers.forEach(function (tier) {
      tier.addEventListener('click', function () {
        tiers.forEach(function (x) { x.classList.toggle('is-on', x === tier); });
        var r = tier.querySelector('input'); if (r) r.checked = true;
        paint();
      });
    });
    paint();

    var err = root.querySelector('[data-cm-err]');
    var varEl = root.querySelector('[data-cm-variant]');
    root.querySelectorAll('[data-cm-atc]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var c = current(); if (!c || btn.classList.contains('is-busy')) return;
        var qty = +c.dataset.qty || 1;
        var id = +(varEl && varEl.value);
        if (!id) return;
        btn.classList.add('is-busy');
        if (err) err.hidden = true;
        var drawer = document.querySelector('cart-drawer');
        var body = { items: [{ id: id, quantity: qty }] };
        if (drawer) { body.sections = ['cart-drawer', 'cart-icon-bubble']; body.sections_url = window.location.pathname; }
        fetch(((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body)
        }).then(function (r) { return r.json(); }).then(function (res) {
          if (res.status && res.description) throw new Error(res.description);
          if (drawer && typeof drawer.renderContents === 'function' && res.sections) {
            drawer.classList.remove('is-empty');
            drawer.renderContents(res);
          } else {
            window.location.href = (window.routes && window.routes.cart_url) || '/cart';
          }
        }).catch(function (x) {
          if (err) { err.textContent = (x && x.message) || 'Something went wrong. Please try again.'; err.hidden = false; }
        }).then(function () { btn.classList.remove('is-busy'); });
      });
    });

    var sticky = root.querySelector('[data-cm-sticky]');
    var mainBtn = root.querySelector('.cm-atc');
    if (sticky && mainBtn && 'IntersectionObserver' in window) {
      sticky.hidden = false;
      sticky.style.display = 'none';
      document.body.classList.add('cm-has-sticky');
      new IntersectionObserver(function (es) {
        es.forEach(function (e) { sticky.style.display = (e.isIntersecting || e.boundingClientRect.top > 0) ? 'none' : ''; });
      }).observe(mainBtn);
    }
  }

  function initAcc(list) {
    list.querySelectorAll('details').forEach(function (d) {
      d.addEventListener('toggle', function () {
        if (!d.open) return;
        list.querySelectorAll('details[open]').forEach(function (o) { if (o !== d) o.open = false; });
      });
    });
  }

  function initVideos() {
    var vids = document.querySelectorAll('.cm-vid video, .cm-feat__m video, .cm-card__m video, .cm-gal__slide video');
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          var v = e.target;
          if (e.isIntersecting) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } else { v.pause(); }
        });
      }, { threshold: 0.35 });
      vids.forEach(function (v) { v.muted = true; v.setAttribute('playsinline', ''); io.observe(v); });
    }
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-cm-sound]'); if (!b) return;
      var v = b.parentElement.querySelector('video'); if (!v) return;
      var turnOn = v.muted;
      document.querySelectorAll('.cm-vid video').forEach(function (o) {
        if (o !== v) { o.muted = true; var ob = o.parentElement.querySelector('[data-cm-sound]'); if (ob) { ob.innerHTML = ICON_MUTE; ob.setAttribute('aria-label', 'Turn sound on'); } }
      });
      v.muted = !turnOn;
      if (turnOn) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
      b.innerHTML = turnOn ? ICON_SOUND : ICON_MUTE;
      b.setAttribute('aria-label', turnOn ? 'Turn sound off' : 'Turn sound on');
    });
  }
  var ICON_MUTE = '<svg viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M3 9h4l5-4v14l-5-4H3z"/><path d="M16 9l5 6M21 9l-5 6" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';
  var ICON_SOUND = '<svg viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M3 9h4l5-4v14l-5-4H3z"/><path d="M15.5 8.5a5 5 0 010 7M18 6a8.5 8.5 0 010 12" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';

  function boot() {
    document.querySelectorAll('[data-cm-main]').forEach(initMain);
    document.querySelectorAll('[data-cm-acc]').forEach(initAcc);
    document.querySelectorAll('[data-cm-top]').forEach(function (a) {
      a.addEventListener('click', function (e) { e.preventDefault(); var t = document.querySelector('.cm-tiers'); if (t) t.scrollIntoView({ behavior: 'smooth', block: 'center' }); });
    });
    initVideos();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
